import { render, staticRenderFns } from "./NewCustomerRegistration.vue?vue&type=template&id=6080c76c&scoped=true"
import script from "./NewCustomerRegistration.vue?vue&type=script&lang=js"
export * from "./NewCustomerRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6080c76c",
  null
  
)

export default component.exports